module.exports = __webpack_public_path__ + "static/files-9c4ac798af47e99c470112567df8ed73.svg";